export enum TOPBAR_POSITION {
  ONTOP = 'onTop',
  SCROLLED = 'scrolled',
}
